import { handleDistrict } from "../handlers/districtHandler";
import { handleSchool } from "../handlers/schoolHandler";
import { handleClass } from "../handlers/classHandler";

// Determine if we should apply role-based defaults given current state
export function shouldApplyDefaultSelection(state, user) {
  if (!user || !user.role) return false;
  if (!state || !state.districts || Object.keys(state.districts).length === 0)
    return false;

  switch (user.role) {
    case "123wellness":
      return state.chosenDistrict === "All Districts";
    case "superadmin":
      return state.chosenSchool === "All Schools";
    case "admin":
    case "teacher":
      return (
        state.chosenClass === "All Classes" ||
        state.chosenClass === "Choose Class" ||
        !state.chosenClass
      );
    default:
      return false;
  }
}

// Compute currentStudents array for the current selection
export function computeCurrentStudents(stateLike) {
  const districts = stateLike.districts || {};
  const cd = stateLike.chosenDistrict;
  const cs = stateLike.chosenSchool;
  const cc = stateLike.chosenClass;

  try {
    if (!districts || Object.keys(districts).length === 0) return [];
    if (cd === "All Districts") {
      const all = Object.keys(districts).flatMap((d) =>
        Object.keys(districts[d] || {}).flatMap((school) =>
          Object.keys(districts[d][school] || {}).flatMap(
            (className) => districts[d][school][className] || [],
          ),
        ),
      );
      return Array.from(new Set(all));
    }
    if (cs === "All Schools") {
      const schools = districts[cd] || {};
      const all = Object.keys(schools).flatMap((school) =>
        Object.keys(schools[school] || {}).flatMap(
          (className) => schools[school][className] || [],
        ),
      );
      return Array.from(new Set(all));
    }
    const schoolObj = districts[cd]?.[cs] || {};
    if (cc === "All Classes") {
      const all = Object.keys(schoolObj).flatMap(
        (className) => schoolObj[className] || [],
      );
      return Array.from(new Set(all));
    }
    if (cc && schoolObj[cc]) {
      return Array.from(new Set(schoolObj[cc] || []));
    }
  } catch (_) {}
  return [];
}

// Apply the appropriate handler for the role's default scope
export function applyDefaultSelection(state, user) {
  if (!user || !user.role) return null;
  let processed = null;
  switch (user.role) {
    case "123wellness":
      if (state.chosenDistrict === "All Districts") {
        processed = handleDistrict(state, "All Districts");
        processed.selectedGroupType = "district";
      }
      break;
    case "superadmin":
      if (state.chosenSchool === "All Schools") {
        processed = handleSchool(state, "All Schools");
        processed.selectedGroupType = "school";
      }
      break;
    case "admin":
    case "teacher":
      // Staff at more than one school start on "All Schools".
      if (state.chosenSchool === "All Schools") {
        processed = handleSchool(state, "All Schools");
        processed.selectedGroupType = "school";
      } else if (
        state.chosenClass === "All Classes" ||
        state.chosenClass === "Choose Class" ||
        !state.chosenClass
      ) {
        processed = handleClass(state, "All Classes");
        processed.selectedGroupType = "class";
      }
      break;
    default:
      break;
  }

  if (!processed) return null;
  // Ensure currentStudents is set for banners/percentages
  processed.currentStudents = computeCurrentStudents({
    ...state,
    ...processed,
  });
  return processed;
}
